import { useQuote } from '../contexts/quoteContext'

export const useDisplayQuoteDetailsCard = () => {
  const { quote, isLoading } = useQuote()

  const hasRelatedInvoices = !!quote?.relatedInvoices?.length

  const shouldDisplayCustomerLink = !!quote?.customer?.externalContactId
  const shouldDisplayDueDate = !!quote?.dueDate && !hasRelatedInvoices
  const shouldDisplayIssueDate = !!quote?.issueDate
  const shouldDisplayStatus = !!quote?.status?.status
  const shouldDisplayRelatedDocumentLinks = hasRelatedInvoices
  const shouldDisplayQuoteDetailsCard =
    shouldDisplayStatus ||
    shouldDisplayIssueDate ||
    shouldDisplayCustomerLink ||
    shouldDisplayDueDate ||
    shouldDisplayRelatedDocumentLinks

  return {
    isLoading,
    hasRelatedInvoices,
    shouldDisplayCustomerLink,
    shouldDisplayDueDate,
    shouldDisplayIssueDate,
    shouldDisplayRelatedDocumentLinks,
    shouldDisplayStatus,
    shouldDisplayQuoteDetailsCard,
  }
}
